import React, { Component } from 'react';
import { images } from '../../../../settings';
import {
  BrowserRouter as Router,
  Link
} from "react-router-dom";

import './Poupanca.scss';

class Poupanca extends Component {
  constructor(props) {
    super(props)
    this.images = images;
  }
  render() {
    return (
      <div className="planos-template">
        <div className="planos-template--risca" style={{backgroundColor: this.props.cor}}></div>
        <div className="planos-template__conteudo">
          <h3 className="h2 h2--500 planos-template__titulo" style={{color: this.props.cor}}>Poupança de longo prazo</h3>
          <h4 className="planos-template__subtitulo">O intuito era harmonizar as regras de investimento e estudar possíveis novos produtos. Confira os resultados:</h4>
          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2019.icone_foguete} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Estimular a demanda por produtos de investimento de longo prazo</h5>
                <p>Relatoria, na IMK, de uma proposta de melhoria na lei dos fundos imobiliários. O objetivo é modernizá-la e aproximá-la da Instrução CVM 555, além de esclarecer as responsabilidades dos prestadores de serviços e cotistas.</p>
                <p>O Código de FIP (Fundo de Investimento em Participações) foi revisado em conjunto com a ABVCAP para alinhar as regras às demais normas da autorregulação – o documento será aprovado e publicado em 2020.</p>
                <p>E, para disseminar conhecimento sobre produtos de longo prazo, foi promovida uma agenda de educação com a Susep e a Previc, falando, respectivamente, de investimentos no exterior e fundos imobiliários.</p>
              </div>
            </div>
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2019.icone_aprimorar} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Aprimorar aparato regulatório</h5>
                <p>Participação em dois subgrupos da IMK que analisaram as normas das entidades abertas e fechadas de previdência complementar. Em relação aos RPPSs (Regimes Próprios de Previdência Social), foi elaborado um estudo sobre melhorias nas normas desses regimes. A apartir dele, apresentamos sugestões de aprimoramentos em um grupo de trabalho da Secretaria de Previdência, do qual fazemos parte.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="planos-template__footer">
          <a className="button button--aylen button--light-green button--border-medium button--size-m button--round-l button--text-thick"
            href="https://www.anbima.com.br/data/files/B5/B5/1F/15/375FE610DC784BE6192BA2A8/Relatorio_de_Iniciativas_2019.pdf "
            target="_blank">
            Saiba mais no Relatório de Iniciativas
          </a>
        </div>
      </div>
    )
  }
}

export { Poupanca }